"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseRequest = void 0;
var PurchaseRequest = /** @class */ (function () {
    function PurchaseRequest() {
    }
    return PurchaseRequest;
}());
exports.PurchaseRequest = PurchaseRequest;
;
//# sourceMappingURL=purchase.request.js.map